import styled from 'styled-components'

import { IconButton } from './Buttons'
import { SearchIcon, XmarkRegularIcon } from './svgIcons'

export const FilterSearchIcon = styled(SearchIcon)`
  color: ${({ theme }) => theme.colors.gray[50]};
  margin-left: 5px;
`

const StyledIconButton = styled(IconButton).attrs({
  size: 'small',
  variant: 'secondaryText',
})<{ $visible?: boolean }>`
  width: 22px;
  height: 22px;
  border: none;
  background: unset;
  padding: 3px;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};

  color: ${({ theme }) => theme.colors.gray[50]};

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.gray[100]};
  }

  &,
  &:before {
    border-radius: 50%;
  }
`

interface FilterClearIconButtonProps {
  onClick: VoidFunction
  visible?: boolean
}

export function FilterClearIconButton({ onClick, visible }: FilterClearIconButtonProps) {
  return (
    <StyledIconButton onClick={onClick} $visible={visible} {...(!visible && { tabIndex: -1 })}>
      <XmarkRegularIcon size={8} />
    </StyledIconButton>
  )
}
